import React, { useState } from "react";
import {
    SovosBox,
    SovosButton,
    SovosDialog,
    SovosDialogActions,
    SovosDialogContent,
    SovosDialogTitle,
    SovosRadioGroup,
    SovosTypography,
} from "mosaic-react";
import { InfoOutlined } from "mosaic-react-icons";

const DatagridMultipleDownloadDialog = (props) => {
    const { data, i18n, cancel, title } = props;
    const { queries, download, locale, totalLinesCsv } = data;
    const [downloadEntity, setDownloadEntity] = useState(queries?.[0]["exportableEntity"]);

    const entityOptions = queries.reduce((acc, { resource, exportableEntity }) => {
        const entity = `${resource}${exportableEntity}`;
        acc.push({ label: i18n`${entity}`, value: exportableEntity });
        return acc;
    }, []);

    const handleEntityChange = (e) => {
        setDownloadEntity(e.target.value);
    };

    return (
        <SovosDialog open={true}>
            <SovosDialogTitle
                showCloseButton
                onClose={() => {
                    cancel && cancel();
                }}
            >
                {title}
            </SovosDialogTitle>
            <SovosDialogContent sx={{ display: "flex", alignItems: "center" }}>
                <SovosRadioGroup
                    sx={{ paddingLeft: "1.25rem" }}
                    value={downloadEntity}
                    onChange={handleEntityChange}
                    options={entityOptions}
                />
            </SovosDialogContent>
            <SovosDialogActions>
                <SovosBox>
                    <SovosBox
                        sx={{
                            marginBottom: "8px",
                            display: "flex",
                            justifyContent: "flex-end",
                            alignItems: "center",
                        }}
                    >
                        <SovosButton
                            variant="text"
                            onClick={() => {
                                cancel && cancel();
                            }}
                        >
                            {i18n`Cancel`}
                        </SovosButton>
                        <SovosButton
                            onClick={() => {
                                const entityToDownload =
                                    queries?.length &&
                                    queries.find(
                                        (elem) => elem.exportableEntity === downloadEntity,
                                    );
                                if (entityToDownload) {
                                    entityToDownload.args.selectedExportableOption = downloadEntity;
                                }
                                download && download([entityToDownload], locale);
                                cancel && cancel();
                            }}
                        >
                            {i18n`Confirm`}
                        </SovosButton>
                    </SovosBox>
                    <SovosBox
                        sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}
                    >
                        <InfoOutlined sx={{ marginRight: "8px" }} />
                        <SovosTypography children={i18n`Limit of ${totalLinesCsv} rows per file`} />
                    </SovosBox>
                </SovosBox>
            </SovosDialogActions>
        </SovosDialog>
    );
};

export default DatagridMultipleDownloadDialog;
